export default __webpack_public_path__ + "static/vision-faebf948bac6df18d394c21d7be49086.gif";